import { render, staticRenderFns } from "./HeroRefs.vue?vue&type=template&id=a1456cde&"
import script from "./HeroRefs.vue?vue&type=script&lang=js&"
export * from "./HeroRefs.vue?vue&type=script&lang=js&"
import style0 from "./HeroRefs.vue?vue&type=style&index=0&id=a1456cde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports